import { useTranslation } from 'react-i18next'
import { GOOGLE_LOCATION_ANCHOR, useSettingsModal } from '@/features/settings'
import { RenderContext } from '../render/context'

/**
 * What the editor's views draw for a block still waiting for its data
 * (`RenderContext.placeholders`), in the panel's language: a map with no
 * Google place says so and opens the settings where one is connected.
 */
export function useEditorPlaceholders(): RenderContext['placeholders'] {
  const { t } = useTranslation()
  const openSettings = useSettingsModal(s => s.open)
  return {
    map: {
      text: t('WEBSITE.MAP_PLACEHOLDER.TEXT'),
      action: t('WEBSITE.MAP_PLACEHOLDER.ACTION'),
      onAction: () => openSettings('restaurant', GOOGLE_LOCATION_ANCHOR)
    }
  }
}
